// extracted by mini-css-extract-plugin
export default {"WordleSelector":"WordSelector_WordleSelector__sh-PW"};